import React, { useEffect, useState } from 'react';
import { UnitCardTypes } from './UnitCardTypes';
import { DisplayModal } from './helpers/ModalHelper';
import { CardComponent } from './helpers/sections/CardComponent';
import { unitCardsConfig } from './helpers/config';
import { frameRequestForRentalInfoUnitCards } from './helpers/genericHelper';
import ErrorBoundaryForUnitCard from './helpers/ErrorBoundaryForUnitCard';
import { fetchRentalInfo } from '@codeparva/v11-tfw-api-library';
import { useSectionData } from '../../sections/rentalPage/components/dynamicForm/hooks/dataContext';

export const UnitCard = ({
  unitsData,
  individualUnitTypeData,
  height,
  isConfirmationPage = true,
  onSetIndividualData,
  path,
  gatsbyPathName,
  facilityId,
  ledgerId,
  modifierType,
  isSurchargeOrDiscountAvailable,
  updatedRate,
  surcharge_or_discount,
  tenantToken,
  facPublicKey,
}: UnitCardTypes.TUnitCardProps) => {
  const {
    billingCycleDetails: { billingCycle },
  } = unitCardsConfig;
  const values = billingCycle;
  const [selected, setSelected] = useState('Monthly');
  const [showModal, onShowModal] = useState(false);
  const [scrollYPixels, setScrollYPixels] = useState(0);
  const [rentalinfoRes, setRentalinfoRes] = useState<any>({});
  const [originalInfoRes, setOriginalInfoRes] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const {
    globalContext: { selectedPromoPlanId },
  } = useSectionData();
  const promoPlanData = selectedPromoPlanId
    ? { promo_plan_ids: [selectedPromoPlanId] }
    : {};

  useEffect(() => {
    setScrollYPixels(typeof window !== 'undefined' ? window.scrollY : 0);
    if (showModal) {
      document.body.style.overflowY = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollYPixels}px`;
    } else {
      const scrollY = document.body.style.top;
      document.body.style.overflowY = '';
      document.body.style.position = '';
      document.body.style.top = '';
      typeof window !== 'undefined'
        ? window.scrollTo(0, parseInt(scrollY || '0') * -1)
        : null;
    }

    async function fetchRentalInfoData() {
      const moveInDate = '';
      const rentalInfoReq = await frameRequestForRentalInfoUnitCards(
        moveInDate,
        ledgerId || '',
        individualUnitTypeData.unitTypeID,
        gatsbyPathName,
        promoPlanData
      );

      const [
        err,
        { data: { data: rentalInfoData = {} } = {} } = {},
      ] = await fetchRentalInfo({
        rentalInfoReq,
        facilityId,
        tenantToken,
        facPublicKey,
      });
      if (err) {
        setHasError(true);
      } else {
        setRentalinfoRes(rentalInfoData);
        setOriginalInfoRes(rentalInfoData);
        setIsLoading(false);
      }
      setIsLoading(false);
    }
    try {
      setHasError(false);
      fetchRentalInfoData();
    } catch (error) {
      setHasError(true);
      setIsLoading(false);
    }
  }, [showModal]);

  useEffect(() => {
    if (isSurchargeOrDiscountAvailable) {
      const copyRentalInfoCharges = { ...originalInfoRes.charges };
      const newConfigs = [
        {
          id: null,
          description: modifierType,
          amount: surcharge_or_discount,
        },
      ];
      if (copyRentalInfoCharges.data) {
        const updatedRentalCharges = {
          ...copyRentalInfoCharges,
          data: surcharge_or_discount
            ? copyRentalInfoCharges.data.concat(newConfigs)
            : copyRentalInfoCharges.data,
        };
        updatedRentalCharges.total_amount = updatedRate;
        setRentalinfoRes({
          ...rentalinfoRes,
          charges: updatedRentalCharges,
        });
      }
    }
  }, [updatedRate]);

  const [foundData, setFoundData] = useState<UnitCardTypes.TUnitData>(
    individualUnitTypeData
  );
  const [rate, setRate] = useState(
    foundData ? foundData.unitTypeRate.Month : 0
  );

  const showSelectedUnit = (selectedId: number) => {
    const foundData = unitsData.unitTypeData.find(
      (item: UnitCardTypes.TUnitData) => {
        return item.unitTypeID === selectedId;
      }
    );
    setFoundData(
      unitsData.unitTypeData.find((item: UnitCardTypes.TUnitData) => {
        return item.unitTypeID === selectedId;
      })
    );
    setRate(foundData.unitTypeRate.Month);
    onShowModal(!showModal);
  };

  const showModalTable = () => {
    onShowModal(!showModal);
  };

  const selectChangedValue = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setSelected(e.target.value);
  };
  const ModalData = {
    unitCardsConfig,
    showModal,
    height,
    showSelectedUnit,
    unitsData,
    foundData,
    onSetIndividualData,
    showModalTable,
    rentalinfoRes,
  };
  const CardData = {
    unitCardsConfig,
    foundData,
    selectChangedValue,
    values,
    selected,
    rate,
    ratesDetails: unitCardsConfig.ratesDetails,
    iconsList: unitCardsConfig.iconsList,
    isConfirmationPage,
    onSetIndividualData,
    showModalTable,
    path,
    gatsbyPathName,
    rentalinfoRes,
    modifierType,
    isSurchargeOrDiscountAvailable,
    updatedRate,
  };

  const SelectUnitCardComponent = () => {
    if (isLoading) {
      return hasError ? (
        <ErrorBoundaryForUnitCard />
      ) : (
        <div className="loaderParentUnitCard">
          <div className="loader"></div>
        </div>
      );
    } else {
      return (
        <>
          <DisplayModal {...ModalData} />
          <CardComponent {...CardData} />
        </>
      );
    }
  };
  return <SelectUnitCardComponent />;
};
